import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=230bae94&scoped=true&lang=pug&"
import script from "./AppPage.vue?vue&type=script&lang=ts&"
export * from "./AppPage.vue?vue&type=script&lang=ts&"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=230bae94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230bae94",
  null
  
)

export default component.exports